module.exports = __webpack_public_path__ + "public/Icons/7Manageusers.svg?aa333293";